import PropTypes from 'prop-types'
import React from 'react'
import { CategoryFilterWrapper as CategoryFilter } from './components'
import {
  ParentCategories,
  TopCategories,
  StoreFilter,
  SaleFilter,
  PriceFilter
} from 'Blocks'

const Filters = props => {
  const queryString = props.location.search
  const isSaleFilterDisabled = !props.products.aggregations.sales

  return (
    <div className="filters-wrapper">
      <div className="filters">
        <TopCategories />
        <ParentCategories parentCategories={props.parentCategories} />
        <CategoryFilter {...props} />
        <PriceFilter data={props.data} queryString={queryString} />
        <SaleFilter {...{ queryString }} isDisabled={isSaleFilterDisabled} />
        <StoreFilter withTitle data={props.data} queryString={queryString} />
      </div>
    </div>
  )
}

Filters.propTypes = {
  data: PropTypes.any,
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  parentCategories: PropTypes.any,
  products: PropTypes.shape({
    aggregations: PropTypes.shape({
      sales: PropTypes.any
    })
  })
}

export default Filters
